// extracted by mini-css-extract-plugin
module.exports = {"root":"Avatar-module__root___Lw1Bw","letters":"Avatar-module__letters___1p_uv","image":"Avatar-module__image___904t6","s":"Avatar-module__s___UEqvz","m":"Avatar-module__m___2I3cJ"};